import { useEffect } from 'react'
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import { Chat } from 'stream-chat-react'
import Box from '@mui/material/Box'
import ChannelList from '../ChannelList'
import DeepLink from '../DeepLink'
import ViewChannel from '../ViewChannel'
import CreateChannel from '../CreateChannel'
import Broadcast from '../Broadcast'
import Welcome from '../Welcome'
import SharedReclips from '../SharedReclips'
import Modals from '../modals'
import PhoneScreens, { PhoneThread } from '../Phone'
import { useDesktop } from 'components/core/SplitPanes'
import 'stream-chat-react/dist/css/index.css'
import './Main.css'
import { useSettings } from 'store/selectors'

const Main = ({ client }) => {
  const { theme } = useSettings()
  const navigate = useNavigate()
  const desktop = useDesktop()

  useEffect(() => {
    const listener = client.on((event) => {
      if (event.type === 'user.updated' && event.user.id === client.userID)
        console.log('is_broadcasting', event.user.is_broadcasting)
    })

    return () => listener.unsubscribe()
  }, [client, navigate])

  return (
    <Chat client={client} theme={`messaging ${theme}`}>
      <DeepLink />
      {/* One list for both layouts, so crossing the breakpoint keeps it and
          the open thread. */}
      <Box
        sx={{
          borderRight: desktop ? 1 : 0,
          borderColor: 'divider',
          width: desktop ? '370px' : '100%',
          height: '100%',
        }}
      >
        <ChannelList />
      </Box>
      {desktop ? (
        <Box
          sx={{
            position: 'relative',
            flex: 1,
            height: '100dvh',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          <ChatRoutes thread={<ViewChannel />} />
        </Box>
      ) : (
        <PhoneScreens routes={<ChatRoutes thread={<PhoneThread />} />} />
      )}
      <Modals />
    </Chat>
  )
}

// What shows beside the list on a desktop, or over it on a phone.
const ChatRoutes = ({ thread }) => (
  <Routes>
    <Route path="" element={thread} />
    <Route path="create" element={<CreateChannel />} />
    <Route path="attachments" element={<SharedReclips />} />
    <Route path="broadcasts/*" element={<Broadcast />} />
    <Route path="welcome/*" element={<Welcome />} />
    <Route path="*" element={<Navigate to="" replace />} />
  </Routes>
)

export default Main
